import { useApi } from '@/shared/api/http';

import type { OrdersQueryParams, OrdersResponse } from '@/entities/order/model/types/order';

export const useOrderService = () => {
  const api = useApi();

  const getOrders = async (params?: OrdersQueryParams, isAuth = true) => {
    try {
      return await api.get<OrdersResponse>('/orders/', isAuth, {
        params,
      });
    } catch (error) {
      console.error('Ошибка при получении истории заказов:', error);
      throw error;
    }
  };

  const getOrderById = async (id: number, isAuth = true) => {
    try {
      return await api.get<any>(`/orders/${id}/`, isAuth);
    } catch (error) {
      console.error('Ошибка при получении заказа по id:', error);
      throw error;
    }
  };

  const createOrder = async (order: any, isAuth = true) => {
    try {
      return await api.post<any>('/orders/create/', isAuth, order);
    } catch (error) {
      console.error('Ошибка при создании заказа:', error);
      throw error;
    }
  };

  return {
    getOrders,
    getOrderById,
    createOrder,
  };
};
